import { render, staticRenderFns } from "./BodyTemperature.vue?vue&type=template&id=a55e08e8"
import script from "./BodyTemperature.vue?vue&type=script&lang=js"
export * from "./BodyTemperature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports